/* eslint-disable react/no-array-index-key */
import { FC } from 'react'
import { IconButton, Input, Button } from 'rsuite'
import { FaPaperPlane, FaPaperclip } from 'react-icons/fa'
import { MdClose, MdCall } from 'react-icons/md'
import useAuth from '../../../hooks/Auth'
import './smsTemplatePreview.scss'

interface SmsTemplateProps {
  open: boolean;
  selectedTemplate?: any;
  selectedTemplatePreviewData?: any;
  isSMS?: boolean;
  onClose: () => void;
  className?: string;
}

const SMSTemplatePreview: FC<SmsTemplateProps> = ({
  open,
  selectedTemplate,
  onClose,
  isSMS,
  className,
  selectedTemplatePreviewData
}) => {
  const { loginUserDetails } = useAuth()

  const displayName = loginUserDetails?.firstname

  if (!open) return null

  return isSMS ? (
    <div className={`sms-container ${className}`}>
      <div className="sms-chat-header">
        <div className="sms-chat-info">
          <IconButton
            circle
            icon={<MdCall />}
            disabled
            className="Phone-Icon"
          />
          <div className="chat-title">
            <h5 className="scrollable-name">{displayName}</h5>
            <p className="status">9370196315</p>
          </div>
        </div>
        <div className="chat-actions">
          <IconButton icon={<MdCall />} disabled />
          <IconButton icon={<MdClose />} onClick={onClose} />
        </div>
      </div>

      <div className="message-list">
        <div className="message-wrapper">
          {' '}
          <div className="message-item">
            <div className="message-card">
              {' '}
              {selectedTemplate.components &&
                selectedTemplate.components.map(
                  (component: any, index: number) => (
                    <div key={component.id || `component-${index}`}>
                      {component.type === 'HEADER' &&
                        component.format === 'IMAGE' &&
                        component.example?.header_handle?.[0] && (
                          <div className="message-image">
                            <img
                              src={component.example.header_handle[0]}
                              alt="Header"
                            />
                          </div>
                        )}
                    </div>
                  )
                )}
              <div className="message-content">
                {selectedTemplate.components &&
                  selectedTemplate.components.map(
                    (component: any, index: number) => (
                      <div key={component.id || `component-${index}`}>
                        {component.type === 'HEADER' && (
                          <div className="header-message">{component.text}</div>
                        )}
                        {component.type === 'BODY' && (
                          <div className="body-message">{component.text}</div>
                        )}
                      </div>
                    )
                  )}
              </div>
              <div className="message-time">10:45 AM</div>
            </div>
          </div>
        </div>
      </div>

      <div className="message-input">
        <IconButton icon={<FaPaperclip />} disabled />
        <Input placeholder="Type a message" disabled className="input-field" />
        <Button appearance="primary" className="cta-button" disabled>
          <FaPaperPlane />
        </Button>
      </div>
    </div>
  ) : (
    <div className={`whatsapp-container ${className}`}>
      <div className="isSMS-chat-header">
        <div className="chat-info">
          <IconButton
            circle
            icon={<MdCall />}
            disabled
            className="Phone-Icon"
          />
          <div className="chat-title">
            <h5 className="scrollable-name">{displayName}</h5>
            <p className="status">9370196315</p>
          </div>
        </div>
        <div className="chat-actions">
          <IconButton icon={<MdCall />} disabled />
          <IconButton icon={<MdClose />} onClick={onClose} />
        </div>
      </div>

      <div className="message-list">
        <div className="message-wrapper">
          <div className="message-item">
            <div className="message-card">
              {selectedTemplatePreviewData?.components.map(
                (component: any, index: number) => (
                  <div key={`component-${index}`}>
                    {component.type === 'HEADER' &&
                      component.format === 'IMAGE' &&
                      component.example?.header_handle?.[0] && (
                        <div className="message-image">
                          <img
                            src={component.example.header_handle[0]}
                            alt="Header"
                          />
                        </div>
                      )}
                  </div>
                )
              )}

              <div className="message-content">
                <div className="header-message">
                  {selectedTemplate?.message}
                </div>
              </div>
            </div>
            <div className="message-time">10:45 AM</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SMSTemplatePreview
